import { memo } from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import { PublicationDealershipSelectorProps } from '../../interfaces';
import styles from '../../publicationDetail.module.scss';

const PublicationDealershipSelector = ({
  type,
  vehicleTypeSelected,
  brand,
  brandsDealerships,
  selectedDealership,
  setSelectedDealership
}: PublicationDealershipSelectorProps) => {
  // Solo mostrar si es para marcas y vehículos nuevos
  // if (vehicleTypeSelected !== "new" || !brand) {
  //   return null;
  // }
  
  // Para myPublication con brand, también mostrar
  if (type === "myPublication" && !brand) {
    return null;
  }

  // if (!brandsDealerships || brandsDealerships.length === 0) {
  //   return null;
  // }

  return (
    <div className={styles.dealershipSelector}>
      <h3 className={styles.selectorTitle}>Elige tu concesionario de preferencia</h3>
      <FormControl fullWidth variant="outlined" className={styles.dealershipFormControl}>
        <Select
          value={selectedDealership || ''}
          onChange={(e) => {
            const newValue = e.target.value;
            console.log('Selected dealership:', newValue);
            setSelectedDealership(newValue);
          }}
          disabled={true}
          displayEmpty
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          }}
          className={styles.dealershipSelect}
          inputProps={{
            classes: {
              icon: styles.selectIcon,
            },
          }}
        >
          <MenuItem disabled value="">
            <span className={styles.placeholder}>Concesionario</span>
          </MenuItem>
          {brandsDealerships && brandsDealerships.length > 0 ? (
            brandsDealerships.map((dealer: any) => {
              const dealerId = dealer.id || dealer._id;
              const dealerName = dealer.name || 'Concesionario';
              console.log('Renderizando concesionario:', dealerId, dealerName);
              return (
                <MenuItem key={dealerId} value={dealerId}>
                  {dealerName}
                </MenuItem>
              );
            })
          ) : (
            <MenuItem disabled>No hay concesionarios disponibles</MenuItem>
          )}
        </Select>
      </FormControl>
    </div>
  );
};

export default memo(PublicationDealershipSelector);
